import { createContext } from 'react';
export interface PersonTimeDisplay {
  timeZone: string;
  label: string;
  mode?: 'moscow' | 'local';
  onModeChange?: (mode: 'moscow' | 'local') => void;
}
/** Presentation only; the owner chooses the display zone for all person summaries in its surface. */
export const PersonTimeZoneContext = createContext<PersonTimeDisplay>({
  timeZone: 'Europe/Moscow',
  label: 'МСК',
});
